var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"d-flex align-center",staticStyle:{"gap":"0.5rem"}},[_c('p',{staticClass:"mb-0 base-body-text"},[_vm._v(" "+_vm._s(_vm.$t("shared.by"))+" ")]),_c('img',{staticClass:"principle-logo",attrs:{"alt":"Principle Assessment","src":require("@/assets/logos/principles-us.svg")}})])
}
var staticRenderFns = []

export { render, staticRenderFns }